import React from 'react';

const About = () => {
  const companyStats = [
    { number: '10+', label: 'Years of Excellence' },
    { number: '50K+', label: 'Happy Customers' },
    { number: '15+', label: 'Premium Products' },
    { number: '7', label: 'Income Streams' }
  ];

  const values = [
    {
      icon: '🎯',
      title: 'Our Mission',
      description: 'Wealth, Family Happiness, and Fulfilling Your Dreams to Become a Great Successful Life'
    },
    {
      icon: '👁️',
      title: 'Our Vision',
      description: 'To be the leading company providing financial freedom and wellness solutions to millions'
    },
    {
      icon: '💎',
      title: 'Our Values',
      description: 'Integrity, Excellence, Innovation, and Customer Success are at the core of everything we do'
    }
  ];

  const milestones = [
    { year: '2014', title: 'Company Founded', description: 'Started with a vision to transform lives' },
    { year: '2016', title: 'MSME Registration', description: 'Officially recognized by Government of India' },
    { year: '2018', title: '10K Customers', description: 'Reached our first major milestone' },
    { year: '2020', title: 'Digital Launch', description: 'Expanded to online platform' },
    { year: '2022', title: '50K Customers', description: 'Growing family of successful entrepreneurs' },
    { year: '2024', title: 'New Products', description: 'Launched premium Ayurvedic product line' }
  ];

  const team = [
    {
      name: 'Management Team',
      role: 'Leadership & Strategy',
      description: 'Experienced professionals with decades of expertise in business and wellness industry'
    },
    {
      name: 'Product Team',
      role: 'Research & Development',
      description: 'Expert team of Ayurvedic specialists and researchers developing quality products'
    },
    {
      name: 'Support Team',
      role: 'Customer Success',
      description: 'Dedicated support team ensuring smooth journey for all our members'
    },
    {
      name: 'Technical Team',
      role: 'Innovation & Technology',
      description: 'Tech experts building robust platform for seamless business operations'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary to-secondary text-white py-20">
        <div className="max-w-7xl mx-auto px-5 text-center">
          <h1 className="text-5xl font-bold mb-6">About DESi MART</h1>
          <p className="text-xl mb-8 text-gray-100">
            KARLO SAPNE MUTTHI ME - Transforming Dreams into Reality
          </p>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 max-w-2xl mx-auto">
            <p className="text-lg">
              We are a registered Micro Enterprise under the Ministry of Micro, Small and Medium Enterprises, 
              Government of India, dedicated to providing financial freedom and wellness solutions.
            </p>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-5">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {companyStats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-4xl font-bold text-primary mb-2">{stat.number}</div>
                <div className="text-gray-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mission Vision Values */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-5">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-secondary mb-4">Our Foundation</h2>
            <p className="text-xl text-gray-600">The principles that guide us every day</p>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {values.map((value, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg p-8 text-center">
                <div className="text-4xl mb-4">{value.icon}</div>
                <h3 className="text-2xl font-bold text-secondary mb-4">{value.title}</h3>
                <p className="text-gray-600">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Company Story */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-5">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-secondary mb-6">Our Story</h2>
              <div className="space-y-4 text-gray-600">
                <p>
                  DESi MART began with a simple yet powerful vision: to empower individuals to achieve financial freedom 
                  while promoting health and wellness through traditional Ayurvedic products.
                </p>
                <p>
                  Founded in 2014, we started as a small team with big dreams. Today, we're a proud MSME-registered 
                  company that has helped thousands of families achieve their dreams of financial independence.
                </p>
                <p>
                  Our journey has been marked by continuous innovation, unwavering commitment to quality, and 
                  dedication to our members' success. We believe that everyone deserves the opportunity to live 
                  their best life, and we're here to make that possible.
                </p>
                <p>
                  From our premium Ayurvedic health supplements to our robust business opportunity, every aspect 
                  of DESi MART is designed with one goal: to help you achieve wealth, family happiness, and fulfill 
                  your dreams.
                </p>
              </div>
            </div>
            <div className="bg-gray-100 rounded-lg p-8">
              <div className="bg-white rounded-lg p-6 shadow-lg">
                <h3 className="text-xl font-bold text-secondary mb-4">What We Believe In</h3>
                <ul className="space-y-3">
                  <li className="flex items-start space-x-3">
                    <span className="text-primary mt-1">✓</span>
                    <span className="text-gray-600">Financial freedom is everyone's right</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="text-primary mt-1">✓</span>
                    <span className="text-gray-600">Traditional wisdom meets modern business</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="text-primary mt-1">✓</span>
                    <span className="text-gray-600">Success is better when shared</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="text-primary mt-1">✓</span>
                    <span className="text-gray-600">Quality products build trust</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="text-primary mt-1">✓</span>
                    <span className="text-gray-600">Your success is our success</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Milestones */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-5">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-secondary mb-4">Our Journey</h2>
            <p className="text-xl text-gray-600">Milestones that mark our growth</p>
          </div>
          
          <div className="relative">
            {/* Timeline Line */}
            <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-primary"></div>
            
            <div className="space-y-12">
              {milestones.map((milestone, index) => (
                <div key={index} className={`flex items-center ${index % 2 === 0 ? 'justify-start' : 'justify-end'}`}>
                  <div className={`w-5/12 ${index % 2 === 0 ? 'text-right pr-8' : 'text-left pl-8 order-1'}`}>
                    <div className="bg-white rounded-lg shadow-lg p-6">
                      <div className="text-2xl font-bold text-primary mb-2">{milestone.year}</div>
                      <h3 className="text-xl font-bold text-secondary mb-2">{milestone.title}</h3>
                      <p className="text-gray-600">{milestone.description}</p>
                    </div>
                  </div>
                  <div className="w-2/12 flex justify-center">
                    <div className="w-8 h-8 bg-primary rounded-full border-4 border-white shadow-lg"></div>
                  </div>
                  <div className={`w-5/12 ${index % 2 === 0 ? 'pl-8' : 'pr-8 order-3'}`}>
                    {/* Empty space for alternating layout */}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-5">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-secondary mb-4">Our Team</h2>
            <p className="text-xl text-gray-600">The people behind your success</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {team.map((member, index) => (
              <div key={index} className="text-center">
                <div className="w-24 h-24 bg-gradient-to-r from-primary to-secondary rounded-full mx-auto mb-4 flex items-center justify-center">
                  <span className="text-3xl text-white">👥</span>
                </div>
                <h3 className="text-xl font-bold text-secondary mb-2">{member.name}</h3>
                <p className="text-primary font-semibold mb-2">{member.role}</p>
                <p className="text-gray-600 text-sm">{member.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Certifications */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-5">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-secondary mb-4">Certifications & Recognition</h2>
            <p className="text-xl text-gray-600">Our commitment to quality and compliance</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-lg shadow-lg p-8 text-center">
              <div className="text-5xl mb-4">🏛️</div>
              <h3 className="text-xl font-bold text-secondary mb-2">MSME Registered</h3>
              <p className="text-gray-600">Government of India Registration</p>
              <p className="text-sm text-gray-500 mt-2">Enterprise Type: Micro • Trading • Classification 2024-25</p>
            </div>
            
            <div className="bg-white rounded-lg shadow-lg p-8 text-center">
              <div className="text-5xl mb-4">🌿</div>
              <h3 className="text-xl font-bold text-secondary mb-2">Ayush Certified</h3>
              <p className="text-gray-600">Ministry of AYUSH Certification</p>
              <p className="text-sm text-gray-500 mt-2">Quality Ayurvedic Products</p>
            </div>
            
            <div className="bg-white rounded-lg shadow-lg p-8 text-center">
              <div className="text-5xl mb-4">🏆</div>
              <h3 className="text-xl font-bold text-secondary mb-2">ISO Compliant</h3>
              <p className="text-gray-600">International Standards</p>
              <p className="text-sm text-gray-500 mt-2">Quality Management Systems</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-primary to-secondary text-white">
        <div className="max-w-7xl mx-auto px-5 text-center">
          <h2 className="text-4xl font-bold mb-4">Join Our Success Story</h2>
          <p className="text-xl mb-8">Be part of a company that values your dreams and helps you achieve them</p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/register"
              className="px-8 py-4 bg-yellow-400 text-gray-900 rounded-lg hover:bg-yellow-300 transition-colors font-bold text-lg"
            >
              Start Your Journey
            </a>
            <a
              href="/contact"
              className="px-8 py-4 bg-transparent border-2 border-white text-white rounded-lg hover:bg-white hover:text-primary transition-colors font-bold text-lg"
            >
              Learn More
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
